/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CContainer, CSpinner } from '@coreui/react';
const HomePage = React.lazy(() => import('../views/HomePage/HomePage'));
import routes from '../routes';

const AppContent = () => {
  return (
    <CContainer
      fluid
      style={{
        padding: 0,
        display: 'flex',
        height: '100%',
        flex: '1',
        // alignItems: 'center',
        // justifyContent: 'center',
      }}
    >
      <Suspense
        fallback={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '100vh' }}
          >
            <CSpinner color="primary" />
          </div>
        }
      >
        <Routes>
          {routes
            .filter((route) => route.path !== '/discloserNotes')
            .map((route, idx) => {
              const ind = idx;
              return (
                route.component && (
                  <Route
                    key={ind}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.component />}
                  />
                )
              );
            })}
          <Route key={100} exact={true} path="/home" name="HomePage" render={<HomePage />} />
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  );
};

export default React.memo(AppContent);
